import React, { FC, useState } from 'react';
import { Icon } from '@/components/atomic/Icon';
import Timer from '@/components/Timer';
import Toast from '@/components/Toast';
import Button from '../Button';

export interface IResentOtpAdornmentProps {
  timeout?: number;
  onResend: () => void;
  title?: string;
  buttonTitle?: string;
  isLoading: boolean;
}

const ResentOTPAdornment: FC<IResentOtpAdornmentProps> = ({
  timeout = 90,
  onResend,
  buttonTitle = 'ارسال مجدد',
  isLoading,
}) => {
  const [canResend, setCanResend] = useState<boolean>(false);

  const handleOtpSend = async () => {
    try {
      await onResend();
      setCanResend(false);
    } catch (e: any) {
      Toast.open({
        variant: 'error',
        children: `${e?.message || e}`,
      });
    }
  };

  const handleOtpTimerEnd = () => {
    setCanResend(true);
  };

  return (
    <>
      {canResend ? (
        <Button
          className="!h-8 !text-xs"
          isLoading={isLoading}
          onClick={handleOtpSend}
        >
          {buttonTitle}
        </Button>
      ) : (
        <Button className="flex !h-8 !w-[90px] justify-between" disabled>
          <Icon className="ml-2" icon="clock" size={20} />
          <div className="w-10">
            <Timer
              timeout={canResend ? 0 : timeout}
              onEnd={handleOtpTimerEnd}
            />
          </div>
        </Button>
      )}
    </>
  );
};

export default ResentOTPAdornment;
